import onElelementExistRunOnce from 'helpers/jquery/onElementExistRunOnce';

onElelementExistRunOnce('.all-spare-parts-index-page', () => {
  import('./internal/all-spare-parts-index-page').then(({ default: Component }) => Component());
});
